import React, { createContext, useContext } from 'react';
import { z } from 'zod';

import { generateRandomBlockId } from '@wp-block-builder/package';

import BlockPlaceholder from './helpers/BlockPlaceholder';
import defineBlock from './helpers/defineBlock';

export const ContainerYieldBlockSchema = defineBlock('ContainerYield', z.strictObject({}));
type TContainerYieldBlock = z.infer<typeof ContainerYieldBlockSchema>;

type TState = JSX.Element;

const Context = createContext<TState | null>(null);
type TProps = {
  children: JSX.Element | JSX.Element[];
  yieldContent: JSX.Element;
};

export function ContainerYieldProvider({ children, yieldContent }: TProps) {
  return <Context.Provider value={yieldContent}>{children}</Context.Provider>;
}

export const getDefaultContainerYieldBlock = (): TContainerYieldBlock => ({
  id: generateRandomBlockId(),
  type: 'ContainerYield',
  style: {},
  props: {},
  sectionProps: {},
});

type ContainerYieldBlockProps = {
  block: TContainerYieldBlock;
};
export default function ContainerYieldBlock(_props: ContainerYieldBlockProps) {
  const content = useContext(Context);
  if (!content) {
    // We should not see read only blocks when rendering the read only version of a document
    // because they are replaced by the nested configuration
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: 24 }}>
          <BlockPlaceholder type="ContainerYield" />
        </div>
      </div>
    );
  }
  return content;
}
